import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzureAppService = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M15.75 16.8C20.93 13.44 27.3 11.69 34.86 11.55M13.02 6.195C16.38 12.145 21.56 16.59 28.56 19.53M9.45 25.2C8.33 26.74 7.42 28.28 6.72 29.82M15.12 23.52C16.52 25.48 18.2 27.23 20.16 28.77M27.09 31.5C30.03 31.92 32.9 31.08 35.7 28.98M35.385 22.89L37.695 23.52M37.8 21C37.8 30.2784 30.2784 37.8 21 37.8C11.7216 37.8 4.2 30.2784 4.2 21C4.2 11.7216 11.7216 4.2 21 4.2C30.2784 4.2 37.8 11.7216 37.8 21ZM16.128 20.328C16.128 22.9955 13.9655 25.158 11.298 25.158C8.63046 25.158 6.468 22.9955 6.468 20.328C6.468 17.6605 8.63046 15.498 11.298 15.498C13.9655 15.498 16.128 17.6605 16.128 20.328ZM26.733 30.807C26.733 32.6627 25.2287 34.167 23.373 34.167C21.5173 34.167 20.013 32.6627 20.013 30.807C20.013 28.9513 21.5173 27.447 23.373 27.447C25.2287 27.447 26.733 28.9513 26.733 30.807ZM35.448 21.567C35.448 23.5387 33.8497 25.137 31.878 25.137C29.9063 25.137 28.308 23.5387 28.308 21.567C28.308 19.5953 29.9063 17.997 31.878 17.997C33.8497 17.997 35.448 19.5953 35.448 21.567Z",
		stroke: "currentColor",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgAzureAppService);
export { ForwardRef as ReactComponent };
